import React, { useId, forwardRef } from 'react';
import './TextField.less';
import { Input, InputHandle, InputProps } from '@progress/kendo-react-inputs';
import { Label, Hint, Error } from '@progress/kendo-react-labels';
import clsx from 'clsx';

interface Props extends InputProps {
  error?: string;
  helperText?: string;
}

const TextField = forwardRef<InputHandle, Props>(
  (
    {
      label,
      required,
      error,
      helperText,
      className,
      autoComplete = 'off',
      ...props
    },
    ref,
  ) => {
    const inputId = useId();

    return (
      <div className={clsx('text-field', className)}>
        {label && (
          <Label
            editorId={inputId}
            className={clsx('text-field__label', {
              'text-field__label_required': required,
            })}
          >
            {label}
          </Label>
        )}

        <Input
          {...props}
          id={inputId}
          ref={ref}
          required={false}
          defaultValue=""
          className={clsx('text-field__input', {
            'text-field__input_error': error,
          })}
          autoComplete={autoComplete}
        />

        {helperText && (
          <Hint className="text-field__helper-text">{helperText}</Hint>
        )}

        {error && <Error className="text-field__error">{error}</Error>}
      </div>
    );
  },
);

TextField.displayName = 'TextField';

export default TextField;
